export default {
    quarterly: 'Quarterly',
    "by-date": "By date",
    year: 'Year',
    month: 'Month',
    start: 'Start',
    end: 'End',
    message: {
        'creation-failed': 'Creation Failed, Please try create a new one.',
        'please-create-a-chart': 'Please create a chart.'
    },
    'divide-chart': 'Divide chart',
    'quarter': 'Quarter'
}